import { ConfigBrand } from '@open-tender/types'
import { selectBrand, useAppSelector } from '@open-tender/cloud'

// @open-tender/types is an npm tarball (not workspace-linked); the installed
// version (yarn.lock pins ^0.4.186) predates this field on ConfigBrand --
// package.json already declares ^0.4.187, which has it. Extend locally
// rather than touch the lockfile (same pattern as ExtConfigBrand in
// SidebarContent.tsx).
type ConfigBrandWithSort = ConfigBrand & { sorts_locations_by_distance?: boolean }

// Single gate for the SORTS_LOCATIONS_BY_DISTANCE brand flag -- every consumer reads this hook.
const useNearestFirstLocations = (): boolean => {
  const brand = useAppSelector(selectBrand) as ConfigBrandWithSort | null
  // brand is null until the config response lands, so coerce rather than return it directly.
  return Boolean(brand?.sorts_locations_by_distance)
}

export default useNearestFirstLocations
